import React from "react";
// import {browserHistory} from "react-router";
import AgreeModal from "../AgreeModal/index";
import {fetchFileContent, trackProtectedContent} from "../../utility/socialLogin";
import {
    // isPageProtectedByCCO,
    openCISCOLoginPopup,
    DEVNET_SELECTED_LINK,
    DEVNET_SELECTED_LINK_ORIGINAL_PAGE_URL, hashCiscoPermission,
} from "../../utility/socialLogin";
const FILEACCESSLEVEL = {
    public: -10,
    socialLoginRequired: 0,
}
export default class extends React.Component {
    constructor() {
        super();
        this.state = {
            showModal: false,
            modalState: null,
            fileLink: null,
        };
    }

    close = () => {
        // Show or hide the Modal
        this.setState({
            showModal: false,
            modalState: null,
            fileLink: null,
        });

        this._deleteCookies();
    };

    getIdFromPath = (url) => {
        if (!url) {
            return "";
        }
        // get file keyname
        if (url.endsWith("/")) {
            url = url.slice(0, -1);
        }

        return url.split("/fileMedia/download/")[1];
    };

    confirmDownload = (url) => {

        // get stored file link
        if (!url) {
            const cookieUtil = window.PubHub.util.cookie;
            url = cookieUtil.getCookie(DEVNET_SELECTED_LINK);
        }

        const keyName = this.getIdFromPath(url);


        fetchFileContent(`${FILE_SERVICE_URL}/download?id=${keyName}`).then((response) => {

            //
            this._deleteCookies();

            // open file
            window.open(response.data.url, "_blank");
            //
            this.setState({
                fileLink: response.data.url,
                showModal: true,
                modalState: "success",
            });

            trackProtectedContent(keyName, response.data.technologyareas || null, response.data.filename);

        }).catch((error) => {
            console.error(error);

            this.setState({
                showModal: true,
                modalState: "fail",
            });

            this._deleteCookies();
        });
    };


    _deleteCookies() {
        const cookieUtil = window.PubHub.util.cookie;
        cookieUtil.deleteCookie(DEVNET_SELECTED_LINK);
        cookieUtil.deleteCookie(DEVNET_SELECTED_LINK_ORIGINAL_PAGE_URL);
    }

    fetchAccessLevel = (fileID) => {
        fetchFileContent(`${FILE_SERVICE_URL}/file/${fileID}`).then((response) => {
            if(response.data.access_level === FILEACCESSLEVEL.public) {
                this.openPublicFile(fileID);
                return;
            } else if(response.data.access_level === FILEACCESSLEVEL.socialLoginRequired) {
                if (!PlatformSDK.isLoggedIn()) {
                    PlatformSDK.openLogin();
                    return;
                }
            } else {
                if (!hashCiscoPermission()) {
                    PlatformSDK.openLogin("Cisco CCO login required.", [{"id": "ciscosso", "name": "CISCO"}])
                    return;
                }
            }
            this.fetchFileInfo(fileID);
        }).catch((error) => {
            console.error(error);
        });
    }

    openPublicFile = (fileID) => {
        window.open(`${FILE_SERVICE_URL}/download?id=${fileID}`, "_self");
    };


    fetchFileInfo = (fileID) => {
        // Try to get the file info
        fetchFileContent(`${FILE_SERVICE_URL}/download?id=${fileID}`).then((response) => {
            // Remove file name cookie
            this._deleteCookies();

            // If the user can download the file
            if (response.data.url) {

                trackProtectedContent(fileID, response.data.technologyareas || null, response.data.filename);

                this.setState({
                    fileLink: response.data.url,
                    showModal: true,
                    modalState: "success",
                });
                // open file
                window.open(response.data.url, "_blank");
            } else if (response.data.terms_id) {
                // If the user has not accepted the file download terms
                this.setState({
                    // fileLink: response.data.url,
                    termID: response.data.terms_id,
                    showModal: true,
                    modalState: "showPolicy",
                });
            }
        }).catch((error) => {
            console.error(error);

            this.setState({
                showModal: true,
                modalState: "fail",
            });

            this._deleteCookies();
        });
    };

    componentWillReceiveProps(nextProps) {
        const {frameUrl, fileUrl} = nextProps;

        // if click protected file to download
        if (fileUrl) {
            // if has permission, directly download
            if (hashCiscoPermission()) {
                const fileID = this.getIdFromPath(fileUrl);
                this.fetchFileInfo(fileID);
            } else {
                // open cisco login,
                // when click cisco, save url
                // if close dialog, delete cookie

                const cookieUtil = window.PubHub.util.cookie;
                cookieUtil.setCookie(DEVNET_SELECTED_LINK, fileUrl);
                cookieUtil.setCookie(DEVNET_SELECTED_LINK_ORIGINAL_PAGE_URL, frameUrl.split("?").shift());


                openCISCOLoginPopup(() => {
                        this._deleteCookies();
                    }
                );
            }
        }
    }


    componentDidMount() {
        const {frameUrl, fileUrl} = this.props;
        const cookieUtil = window.PubHub.util.cookie;
        const selectedLink = cookieUtil.getCookie(DEVNET_SELECTED_LINK);
        const originalUrl = cookieUtil.getCookie(DEVNET_SELECTED_LINK_ORIGINAL_PAGE_URL);

        // if user login with cisco sso
        // if cookie store download file link
        // and frame url is the same
        const fileId = this.getIdFromPath(this.props.fileUrl);
        if (fileId) {
            this.fetchAccessLevel(fileId);
        }
    }

    render() {
        const {frameUrl, fileUrl = ""} = this.props;

        if (this.state.showModal) {
            return (<AgreeModal
                onToggle={this.close}
                onConfirm={(() => this.confirmDownload(fileUrl))}
                state={this.state.modalState}
                fileLink={this.state.fileLink}
                termID={this.state.termID}
            />);
        }

        return null;
    }
}
